import { FUNCTION_KEY } from "./function";

const ACCOUNTTYPE = {
  ACCOUNT_PAYMENT: "10",
  ACCOUNT_TERM_DEPOSIT: ["30", "40"],
  ACCOUNT_LOAN: "50",
};

const ACCOUNT_OR_PHONE = {
  ACCOUNTNO: "ACCOUNTNO",
  PHONE: "PHONE",
};

const TEMPLATE_TYPE = {
  ALL_TEMPLATE: "",
  INTERNAL_TRANSFER: "INTERNAL_TRANSFER", // Nội bộ
  INTERBANK_TRANSFER: "INTERBANK_TRANSFER", // Liên ngân hàng
  INTERBANK_FAST_TRANSFER: "INTERBANK_FAST_TRANSFER", // 247
  BILLING_TEMPLATE: "BILLING", // Hoá đơn
  TOP_UP_TEMPLATE: "TOPUP", // Nạp tiền
  DEPOSIT_TO_STOCK_TRADE_ACCOUNT: "DEPOSIT_TO_STOCK_TRADE_ACCOUNT", // chuyển tiền chứng khoán
  CASH_BY_CODE_TEMPLATE: "CASH_BY_CODE", // chuyển tiền qua code
  CREDIT_CARD_PAYMENT_TEMPLATE: "CREDIT_CARD_PAYMENT", // thanh toán thẻ
  PREPAID_CARD_TOPUP_TEMPLATE: "PREPAID_CARD_TOPUP", // nạp tiền vào thẻ trả trước
};

const AUTHORIZATION_TYPE = {
  SMS: "sms",
  SMART_OTP: "ipso",
};

const CARD = {
  CARD_TYPE: {
    CREDIT: "CREDIT", // Thẻ tín dụng
    DEBIT: "DEBIT", // Thẻ ghi nợ nội địa
    DEBIT_MASTER: "DEBIT_MASTER", // Thẻ ghi nợ quốc tế
    PREPAID: "PREPAID", //trả trước
    PREPAID_STANDARD: "PREPAID_STANDARD", //trả trước định danh
    PREPAID_INCOGNITO: "PREPAID_INCOGNITO", //trả trước vô danh
  },
  CARD_PAYMENT_TYPE: {
    CRD: "CRD", // Thanh toán cá nhân
    ACT: "ACT", // Thanh toán hộ
  },
  CARD_DEBIT_TYPE: {
    CARD_TOTAL_DEBIT: "CARD_TOTAL_DEBIT", //thanh toán toàn bộ,
    CARD_MINIMUM_DEBIT: "CARD_MINIMUM_DEBIT", // thanh toán tối thiểu,
    CARD_CUSTOM_DEBIT: "CARD_CUSTOM_DEBIT", // thanh toán tuỳ chọn
  },
  CARD_HISTORY_TRANS_TYPE: "CARD_HISTORY_TRANS_TYPE", // Lịch sử giao dịch thẻ
  CARD_TRANS_TYPE: {
    CR: "CR", // Ghi có
    DB: "DB", // Ghi nợ
  },
};

const TRANSFER = {
  TRANSFER_247_TYPE: {
    ACC: "ACC", // TK thanh toán
    CRD: "PAN", // Thẻ ATM
  },
  TRANSFER_FEE_TYPE: {
    O: "O", // người gửi chịu phí
    I: "I", // người nhận chịu phí
  }
}

export const Constant = {
  ENGLISH: "en",
  VIETNAMESE: "vi",
  ACCOUNTTYPE: ACCOUNTTYPE,
  ACCOUNT_OR_PHONE: ACCOUNT_OR_PHONE,
  TEMPLATE_TYPE: TEMPLATE_TYPE,
  AUTHORIZATION_TYPE: AUTHORIZATION_TYPE,
  FUNCTION: FUNCTION_KEY,
  PRODUCT_CODE_PAYMENT: "PRD10", // Mã sp tk thanh toán
  PRODUCT_CODE_PRD26: "PRD26", // Mã sp tk thấu chi
  CREDIT: "CREDIT",
  DEBIT: "DEBIT",
  TRANS_CARD: "TRANS_CARD",
  FEE: "FEE",
  AMOUNT: "AMOUNT",
  CARD: CARD,
  TRANSFER: TRANSFER,
};
